/**
 * Determines if local storage is available in the browser.
 * Taken from https://developer.mozilla.org/en-US/docs/Web/API/Web_Storage_API/Using_the_Web_Storage_API#feature-detecting_localstorage.
 * If the user has cookies blocked or is in a private browsing mode, local storage will not be available.
 * @returns boolean
 */
export const localStorageAvailable = () => {
    let storage = null;
    try {
        storage = window.localStorage;
        const x = '__storage_test__';
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    }
    catch (e) {
        return !!(e instanceof DOMException &&
            e.name === 'QuotaExceededError' &&
            // acknowledge QuotaExceededError only if there's something already stored
            storage &&
            storage.length !== 0);
    }
};
